module.exports = __webpack_public_path__ + "img/A08-20160664-001.3e98452e.jpg";